export default __webpack_public_path__ + "static/ivanovo-39d950e850cb47f44e963693e5d6b629.jpg";